import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { CircleButton } from '@tmsw/powerups.ui.buttons.circle-button';
import { usePageConfig } from '@tmsw/powerups.config.page.provider';
import './SkipButton.css';
// import { useEffect, useState } from 'react';

export type SkipButtonProps = {
  onClick?: any;
};

export const SkipButton = (props: SkipButtonProps) => {
  const { __t } = useTranslation();
  const skipTarget = useStore((state) => state.skipTarget);
  const setShowSkip = useStore((state) => state.setShowSkip);
  const isPlaying = useStore((state) => state.isPlaying);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setIsPauseEnabled = useStore((state) => state.setIsPauseEnabled);
  const page = useStore((state) => state.currentPage);

  const { pagesMap } = usePageConfig();
  // const currentCueMetadata = useStore((state) => state.currentCueMetadata);

  const styles = {
    height: 'var(--ui-buttons-circle-button-height)',
    width: 'var(--ui-buttons-circle-button-width)',
    zIndex: '90',
    padding: 0,
    display: 'block',
  };

  return (skipTarget &&
    (isPauseEnabled || isPlaying) &&
    page === pagesMap.SPLASH) ||
    page === pagesMap.ONBOARDING ? (
    <CircleButton
      icon={'skip'}
      style={styles}
      ariaLabel={__t('buttons.skip.ariaLabel', 'GENERAL')}
      onClick={(e: any) => {
        setShowSkip(false);
        if (props.onClick) props.onClick(e);
        if (!isPlaying) setIsPauseEnabled(false); // Only when video is paused, clicking the Skip button will set IsPauseEnabled to False
      }}
    />
  ) : null;
};
